export function showNotificationInTitle() {
    document.title = "🔔 New notification! - ZONI®";
}

export function removeNotificationFromTitle() {
    document.title = "ZONI®";
}
